'use client'
import { PrismicRichText } from '@prismicio/react';
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';

/**
 * @typedef {import("@prismicio/client").Content.BeforeAndAfterSlice} BeforeAndAfterSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<BeforeAndAfterSlice>} BeforeAndAfterProps
 * @param {BeforeAndAfterProps}
 */
const Handle = ({ color }) => <div className='relative flex items-center justify-center'>
  <div className='bg-dark-grey h-screen w-[2px] absolute'>
  </div>
  <div className={`absolute h-28 w-16 rounded-full bg-${color} border-2 border-dark-grey`}></div>
</div>


const BeforeAndAfter = ({ slice, index, context }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-${slice.primary.bg_color} ${index !== 0 ? 'border-t-2 border-dark-grey' : ''} overflow-x-hidden pb-[40px] md:pb-20 relative bg-grain`}>
      <div className="pb-[54px] pt-[87px] md:pb-10 md:pt-[100px] px-4 md:px-7 lg:px-10 relative z-[10] max-w-[1400px] m-auto">
        <PrismicRichText field={slice.primary.title} />
        <div className="p-like mb-5">
          <PrismicRichText field={slice.primary.sub_title} />
        </div>
        <div className="rounded-3xl overflow-hidden border-2 border-dark-grey">
          <ReactCompareSlider className="h-[360px] md:h-[500px]"
            handle={<Handle color={slice.primary.bg_color} />}
            itemOne={<ReactCompareSliderImage src={context.isMobileViewer ? `${slice.primary.before_picture.url}&h=400` : slice.primary.before_picture.url} alt="Image one" />}
            itemTwo={<ReactCompareSliderImage src={context.isMobileViewer ? `${slice.primary.after_picture.url}&h=400` : slice.primary.after_picture.url} alt="Image two" />}
          />
        </div>
      </div>
    </section>
  );
};

export default BeforeAndAfter;
